import { frontendSettings } from "../../../Libraries/CoreWeb/CoreWeb/Features/Shared/frontendSettingsHelper";
import { SmartGuideFrontendSettings } from "./Generated/SmartGuideFrontendSettings";
import { FrontendSettingsConstants } from "../../../Libraries/CoreWeb/CoreWeb/Features/Shared/Generated/FrontendSettingsConstants";

export const smartGuideFrontendSettings = frontendSettings as unknown as SmartGuideFrontendSettings;
export const webTranslations = smartGuideFrontendSettings.webTranslations;
export let uiLanguage = smartGuideFrontendSettings.uiLanguage;
export let contentLanguage = smartGuideFrontendSettings.contentLanguage;

export function refreshSmartGuideFrontendSettings(root: ParentNode = document): void {
    const script = root.querySelector<HTMLScriptElement>(`#${FrontendSettingsConstants.frontendSettingsScriptId}`);
    if (!script?.textContent) return;
    const settings = JSON.parse(script.textContent) as SmartGuideFrontendSettings;
    if (!settings.webTranslations) return;
    Object.assign(webTranslations, settings.webTranslations);
    Object.assign(smartGuideFrontendSettings, settings, { webTranslations });
    uiLanguage = settings.uiLanguage;
    contentLanguage = settings.contentLanguage;
}

export function formatTranslation(template: string, ...values: ReadonlyArray<string | number>): string {
    return template.replace(/\{(\d+)\}/g, (_match, rawIndex: string) => {
        const index = Number(rawIndex);
        if (index >= values.length) throw new Error(`Missing translation argument ${index}.`);
        return String(values[index]);
    });
}
